import { IParseOptions, parse } from 'qs';

export const getQueryParams = <T extends Record<string, string>>(query: string, config: IParseOptions = { ignoreQueryPrefix: true }) => {
  return parse(query, config) as T;
};
